import React, { Component } from 'react'

// import styles from './timescale-selector.module.css'
// import styles from

const timescales = [
  { value: 1, unit: 'week' },
  { value: 2, unit: 'weeks' },
  { value: 1, unit: 'month' },
  { value: -1 } // All Time
]

export default class TimescaleSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedIndex: 3
    }

    this.styles = props.styles
  }

  handleClick = (timescale, index) => {
    if (index !== this.state.selectedIndex) {
      this.setState({ selectedIndex: index })
      this.props.handleTimeScaleChange(timescale)
    }
  }

  renderButtons = () => {
    const { selectedIndex } = this.state

    return (
      <div className={this.styles.timescaleContainer}>
        {timescales.map((timescale, index) => (
          <p
            key={index}
            className={
              selectedIndex === index
                ? this.styles.fab
                : this.styles.clickableText
            }
            onClick={() => this.handleClick(timescale, index)}
            tabIndex="0"
            role="button"
            onKeyDown={e => {
              const key = e.which
              if (key === 13 || key === 32) this.handleClick(timescale, index)
            }}
          >
            {timescale.value > 0
              ? `${timescale.value} ${timescale.unit}`
              : 'All Time'}
          </p>
        ))}
      </div>
    )
  }

  render() {
    return this.renderButtons()
  }
}
